function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "variant", "corners", "expand", "transparent", "light", "subtle", "children", "size", "loading", "initializing", "disabled", "type", "multiple", "accept", "onChange", "active", "icon", "equalSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from "../Box";
import { m, e } from "../../lib/bem";
import cls from "../../lib/cls";
import buttonClasses from "../../../design-system/scss/components/button.module.scss";
import { Spinner } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classNames;
  var className = _ref.className,
    variant = _ref.variant,
    corners = _ref.corners,
    expand = _ref.expand,
    transparent = _ref.transparent,
    light = _ref.light,
    subtle = _ref.subtle,
    children = _ref.children,
    size = _ref.size,
    loading = _ref.loading,
    initializing = _ref.initializing,
    disabled = _ref.disabled,
    type = _ref.type,
    multiple = _ref.multiple,
    accept = _ref.accept,
    onChange = _ref.onChange,
    active = _ref.active,
    icon = _ref.icon,
    equalSize = _ref.equalSize,
    props = _objectWithoutProperties(_ref, _excluded);
  var baseClass = 'c-button';
  var component = type === 'file' ? 'label' : 'button';
  var classNames = (_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, baseClass, true), m(variant, baseClass), !!variant), m(corners, baseClass), !!corners), m('expand', baseClass), expand), m('transparent', baseClass), transparent), m('light', baseClass), light), m('subtle', baseClass), subtle), m(size, baseClass), size && size !== 'default'), m('equal-size', baseClass), equalSize), 'is-loading', loading), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, 'is-initializing', initializing), 'is-disabled', disabled), 'is-active', active), className.split(' '), true));
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    component: component,
    type: type === 'file' ? null : type
  }, props), {}, {
    disabled: disabled || initializing,
    ref: ref,
    className: cls(classNames, buttonClasses),
    children: [/*#__PURE__*/_jsx("div", {
      className: cls([e('text', baseClass)], buttonClasses),
      children: children
    }), icon && /*#__PURE__*/_jsx("div", {
      className: cls([e('icon', baseClass)], buttonClasses),
      children: icon
    }), loading && /*#__PURE__*/_jsx("div", {
      className: cls([e('spinner', baseClass)], buttonClasses),
      children: /*#__PURE__*/_jsx(Spinner, {})
    }), type === 'file' && /*#__PURE__*/_jsx(Box, {
      component: "input",
      type: "file",
      multiple: multiple,
      accept: accept,
      onChange: onChange,
      hide: true
    })]
  }));
});
Button.defaultProps = {
  variant: null,
  corners: null,
  type: 'button',
  expand: false,
  transparent: false,
  size: null,
  light: false,
  subtle: false,
  className: '',
  loading: false,
  children: null,
  initializing: false,
  disabled: false,
  multiple: null,
  accept: null,
  onChange: null,
  active: false,
  icon: null,
  equalSize: false
};
Button.propTypes = {
  variant: PropTypes.oneOf(['default', 'outline', 'outline-white', 'icon', 'icon-circle', 'white']),
  corners: PropTypes.oneOf(['square', 'rounded', 'round']),
  type: PropTypes.oneOf(['button', 'submit', 'file']),
  expand: PropTypes.bool,
  transparent: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  light: PropTypes.bool,
  subtle: PropTypes.bool,
  loading: PropTypes.bool,
  initializing: PropTypes.bool,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  icon: PropTypes.node,
  equalSize: PropTypes.bool
};
export default Button;